import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Menu, IconButton, Divider, InputBase, Paper,  } from '@mui/material';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { styled, alpha } from '@mui/material/styles';
import Iconify from '../../../reusable-components/iconify';
import { addNewRentalItemNote } from '../../../redux/slices/rentals';
import { useDispatch } from '../../../redux/store';
import { useScopeCheck } from '../../../reusable-components/scopes';


RentalItemsNotesModal.propTypes = {
  params: PropTypes.object,
};

export default function RentalItemsNotesModal({ params }) {
  const hasSubmitAccess = useScopeCheck(['Rental-Order-Submit'], true)
  const closedRental = params?.row?.closedOn != null;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClickOpen = (event) => {
    event.openTicket = true;
    setAnchorEl(event.currentTarget);}
 
   const dispatch = useDispatch();
    const [message, setMessage] = useState(params?.row?.itemNote);
  
    useEffect(() => {
      setMessage(params?.row?.itemNote);
    },[params?.row?.itemNote]);
  
    const handleClose = () => {
    setMessage(params?.row?.itemNote)
    setAnchorEl(null);
  };
    const handleSend = async () => {
    const url = new URL(window.location.href);
    const orderStatus = url.pathname.split('/').filter(Boolean).pop().split('-')[0];
     try {
        await dispatch( 
          addNewRentalItemNote({
            message,
            cartItemId: params?.row?.cartItemId,
            orderStatus
          })
        );
        handleClose()
      } catch (error) {
        console.error(error);
      }
    };

  return (
    <>
      <Tooltip arrow title={message != null ? 'Open order note' : 'Add note'}>
        <IconButton
          onClick={handleClickOpen}
          sx={{
            opacity: 0.8,
          }}
        >
          {message != null ? (
            <FileOpenIcon width={28} height={28} color="info" />
          ) : hasSubmitAccess && !closedRental ? (
            <NoteAddIcon color="secondary" width={28} height={28} /> 
          ): ""}
        </IconButton>
      </Tooltip>

      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
      
        <Paper component="form" sx={{ display: 'flex', alignItems: 'center', border: 'solid 1px #0075db', mt: 1 }}>
          <InputBase
            sx={{
              ml: 1,
              flex: 1,
              padding: 0,
              lineHeight: '16px',
              pt: 1,
              pb: 1
            }}
            placeholder="Add note"
            multiline
            value={message}
            onChange={(e) => {
              if(hasSubmitAccess && !closedRental)
               setMessage(e.target.value);
            }}
          />
        {hasSubmitAccess && !closedRental && <>
          <Divider sx={{ height: 20, ml: 0.5 }} orientation="vertical" />
          <IconButton color="info" onClick={handleSend}>
            <Iconify icon="material-symbols-light:note-add-outline-sharp" width={20} height={20} />
          </IconButton>
          </> }
        </Paper>

      </StyledMenu>
    </>
  );
}

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    maxHeight: 300,
    color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      },
    },
  },
}));

